import { useRouter } from 'next/router'

import { ResultErrorGeneric } from '@/components/common/result'
import { LoadingSpinner } from '@/components/ui/spinners'
import { projectUrls } from '@/config/urls/project/project'
import { useWorkspaces } from '@/hooks/useWorkspaces'
import { useHttpFetcher } from '@/utils/http'

import { Project } from '@/types/index.d'

export function WrongWorkspace({
  children,
}: {
  children: React.ReactNode
}): JSX.Element {
  const router = useRouter()
  const { repositoryId, environmentId } = router.query
  const { current: workspace } = useWorkspaces()
  const { data: projectData, isLoading: isProjectDataLoading } =
    useHttpFetcher<Project>({
      url: projectUrls.getProjectInfo({
        workspaceId: workspace?.id,
        projectId: (repositoryId ? repositoryId : environmentId) as string,
      }),
    })

  if (isProjectDataLoading) {
    return <LoadingSpinner loading={true} />
  }

  return projectData?.id === undefined && (repositoryId || environmentId) ? (
    <ResultErrorGeneric componentId="WrongWorkspace" />
  ) : (
    <>{children}</>
  )
}
